/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Xmlid6614IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Xmlid6614Icon(props: Xmlid6614IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 151 543"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M139.264 533.669c-2.209 6.952-9.908 10.5-16.615 7.633l-50.984-21.8c-5.536-2.368-8.422-8.481-6.774-14.273 2.27-7.977 5.046-20.215 5.993-34.763 2.117-32.492-5.562-61.446-22.824-86.06-23.55-33.577-34.28-66.813-32.808-101.606 1.258-29.719 11.07-55.724 20.56-80.874 6.351-16.833 12.35-32.733 16.04-49.89 7.505-34.886-29.66-69.83-47.29-84.144a12.327 12.327 0 0 1-2.525-16.36L32.333 5.555c3.944-5.988 12.143-7.37 17.82-2.99 10.01 7.721 25.442 20.834 40.216 38.245 34.8 41.011 48.341 85.25 39.159 127.936-4.938 22.95-12.61 43.286-19.379 61.228-16.545 43.851-25.66 68.005 2.96 108.813 54.934 78.331 36.231 163.167 26.155 194.882"
        }
      ></path>
    </svg>
  );
}

export default Xmlid6614Icon;
/* prettier-ignore-end */
